// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-right-column';

export const Component = () => (
  <path d='m14.512 16.619 4.31-3.88H4.885v-.958h13.937l-4.31-3.88.67-.766 4.933 4.454h.048l.287.335.335.288v.096l-.335.287-.287.335h-.048l-4.933 4.454-.67-.766ZM.958 4.406v15.709a3.573 3.573 0 0 0 1.054 2.394 3.576 3.576 0 0 0 2.394 1.054h7.376V15.71h.958v7.854h7.376a3.573 3.573 0 0 0 2.394-1.054 3.576 3.576 0 0 0 1.054-2.394V4.406a3.573 3.573 0 0 0-1.054-2.394A3.576 3.576 0 0 0 20.116.958H12.74v7.854h-.958V.958H4.406a3.573 3.573 0 0 0-2.394 1.054A3.576 3.576 0 0 0 .958 4.406Zm3.448 20.115c-1.197 0-2.25-.431-3.113-1.293A4.267 4.267 0 0 1 0 20.115V4.406c0-1.197.431-2.25 1.293-3.113A4.267 4.267 0 0 1 4.406 0h15.709c1.198 0 2.25.431 3.113 1.293a4.267 4.267 0 0 1 1.293 3.113v15.709c0 1.198-.431 2.25-1.293 3.113a4.267 4.267 0 0 1-3.113 1.293H4.406Z' />
);

export const viewBox = '0 0 25 25';
